import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { IMenuFilter } from '@nimbus-library/features/menu';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';

export class AuthenticationFilter implements IMenuFilter {
  public constructor(
    private readonly store: Store,
    private readonly authenticationService: IAuthenticationService,
  ) {}

  public validate$(): Observable<boolean> {
    return this.authenticationService.isAuthenticated$;
  }
}
